import { useQuery } from '@tanstack/react-query'

import {
  getCircleBoothInfo,
  getCircleInfoDetail,
  getCircleList,
} from '~/features/circle-info/apis/circleInfo'

const CIRCLE_INFO_KEYS = {
  base: [{ scope: 'circleInfo' }] as const,
  info: (eventId: string) =>
    [{ ...CIRCLE_INFO_KEYS.base[0], entity: 'info', eventId }] as const,
}

export const useCircleList = (
  rowPerPage: number,
  page: number,
  eventId: string,
  keyword: string,
) => {
  return useQuery({
    queryKey: [rowPerPage, page, eventId, keyword],
    queryFn: () => getCircleList(rowPerPage, page, eventId, keyword),
  })
}

export const useCircleInfo = (id: string) => {
  return useQuery({
    queryKey: [id],
    queryFn: () => getCircleInfoDetail(id),
  })
}

export const useCircleBoothInfo = (eventId: string) => {
  return useQuery({
    queryKey: CIRCLE_INFO_KEYS.info(eventId),
    queryFn: () => getCircleBoothInfo(eventId),
    enabled: !!eventId,
  })
}
